import styled, { css } from 'styled-components'
import { P, Strong } from '../../shared_components/Library/Typeography'
import { Box } from '../../shared_components/UI/Box'
import { theme } from '../../theme'
import { ReactNode } from 'react'

export function OutcomeAlert({
  label,
  description,
  descriptionStyles,
  type,
  onClick,
  bordered = true,
  boxed = false,
}: {
  label?: string
  description?: ReactNode
  descriptionStyles?: {
    s: any
    c: any
  }
  type: keyof typeof theme.colors.function
  onClick?: () => void
  bordered?: boolean
  boxed?: boolean
}) {
  return (
    <OutcomeAlertBox
      ac
      fu
      aw
      g={8}
      padH={boxed ? 'm' : 12}
      padV={boxed ? 'm' : 8}
      type={type}
      onClick={onClick}
      bordered={bordered}
      boxed={boxed}
    >
      {type === 'success' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
            stroke="#39FF41"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {type === 'error' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
            stroke="#FF5252"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      <Box dc g={2}>
        {label && (
          <Strong s="M" fw="semibold" c="text-primary" ls="-0.28px">
            {label}
          </Strong>
        )}
        {description && (
          <P
            s={descriptionStyles?.s ?? 'S'}
            fw="regular"
            c={descriptionStyles?.c ?? 'text-secondary'}
          >
            {description}
          </P>
        )}
      </Box>
      {type === 'error' && onClick && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M5 12H19M19 12L12 5M19 12L12 19"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </OutcomeAlertBox>
  )
}

const OutcomeAlertBox = styled(Box)<{
  type: keyof typeof theme.colors.function
  onClick?: () => void
  bordered?: boolean
  boxed?: boolean
}>`
  height: 40px;
  border-radius: var(--units-88, 88px);
  border: var(--units-1, 1px) solid ${({ type }) => theme.colors.function[type]};
  background: var(--surface-primary, #080808);

  ${({ onClick }) =>
    onClick &&
    css`
      cursor: pointer;
    `}

  ${({ bordered }) =>
    !bordered &&
    css`
      border: none;
      padding: 0;
    `}

  ${({ boxed }) =>
    boxed &&
    css`
      height: auto;
      border-radius: var(--units-12, 12px);
    `}
`
